import { ProductLabelTextHelper } from '../labelTextHelper/ProductLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = [
    'productId',
    'latestProductCost',
    'latestEstimatedShippingFee',
    'dateCreateAt',
    'dateModifyAt'
];

export const ProductHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: ProductLabelTextHelper.getLabelText.productId, value: 'productId' },
            { text: ProductLabelTextHelper.getLabelText.sku, value: 'sku' },
            { text: ProductLabelTextHelper.getLabelText.title, value: 'title' },
            { text: ProductLabelTextHelper.getLabelText.description, value: 'description' },
            { text: ProductLabelTextHelper.getLabelText.categoryCode, value: 'categoryCode' },
            { text: ProductLabelTextHelper.getLabelText.dateCreateAt, value: 'dateCreateAt', format: 'datetime' },
            { text: ProductLabelTextHelper.getLabelText.dateModifyAt, value: 'dateModifyAt', format: 'datetime' },
            { text: ProductLabelTextHelper.getLabelText.latestProductCost, value: 'latestProductCost' },
            {
                text: ProductLabelTextHelper.getLabelText.latestEstimatedShippingFee,
                value: 'latestEstimatedShippingFee'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: ProductLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
